module.exports = __webpack_public_path__ + "img/cgzq.b7fdb8e.png";